export default __webpack_public_path__ + "static/media/filter.3b222f18.svg";